import {t} from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDialogContainer from '../../baseContainers/BaseDialogContainer';
import DivContainer from '../../components/DivContainer';
import InputMultiSelectComponent from '../../components/inputs/InputMultiSelectComponent';
import InputTextComponent from '../../components/inputs/InputTextComponent';
import UserModel from '../../model/UserModel';
import InternalUserService from '../../services/InternalUserService';
import UserRoleService from '../../services/UserRoleService';
import AccountService from '../../services/AccountService';
import InputDropdownComponent from '../../components/inputs/InputDropdownComponent';
import SettingService from '../../services/SettingService';
import Card from 'react-bootstrap/Card';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';

class UserDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new InternalUserService());
        this.settingService = new SettingService();
        this.state = {
            element: new UserModel(),
            elementId: props.elementId,
            viewMode: this.props.viewMode,
            activeIndex: 0,
            locales: [],
        };
        this.userId = this.authService.getProfile().userId;
        this.userRoleService = new UserRoleService();
        this.userService = new AccountService();
        this.remindPassword = this.remindPassword.bind(this);
        window.console.log(props);
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    prepareElementBeforeRequest(element) {
        const request = JSON.parse(JSON.stringify(element));
        this.userId === this.state.element.id ? (request.roles = null) : (request.roles = request.roles.map((r) => r.enumValue));
        return request;
    }
    initBeforeSetElement() {
        this.enumService
            .getEnumList('UserRoleType', this.translate)
            .then((roles) =>
                this.setState({
                    roles,
                })
            )
            .catch(() => {
                this.props.showErrorMessage(t('user.error.getRoles'));
            });
        this.settingService
            .getSupportedLocales()
            .then((locales) =>
                this.setState({
                    locales,
                })
            )
            .catch((err) => {
                this.props.showErrorMessage(err);
            });
    }
    renderFooter() {
        const footerItems = this.prepareFooterItems();
        if (footerItems !== undefined && footerItems.length > 0 && footerItems.filter((f) => f.rendered !== false)?.length > 0) {
            return (
                <React.Fragment>
                    <hr className='line-footer-user-dialog' />
                    {this.prepareFooter(footerItems)}
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
    prepareFooterItems() {
        const {viewMode} = this.props;
        switch (viewMode) {
            case 'EDIT':
                return [
                    {
                        label: t('details.save'),
                        className: 'float-left',
                        onClick: this.handleFormSubmit,
                        id: 'saveUserButton'
                    },
                    {label: t('details.cancel'), onClick: this.props.onHide, className: 'gray'},
                    {label: t('user.setPassword'), className: 'float-right', onClick: this.remindPassword},
                ];
            case 'NEW':
                return [
                    {
                        label: t('details.save'),
                        className: 'float-left',
                        onClick: this.handleFormSubmit,
                         id: 'saveUserButton'
                    },
                    {label: t('details.cancel'), onClick: this.props.onHide, className: 'gray'},
                ];
            case 'VIEW':
            default:
                return [];
        }
    }
    remindPassword() {
        this.blockUi();
        this.service
            .remindPassword(this.state.element.id, this.state.element.locale)
            .then(() => {
                this.persistMessage('success', '', t('user.remindPasswordSuccess'));
                this.props.afterSave();
            })
            .catch((err) => {
                this.props.showErrorMessage(err.message);
                this.unblockUi();
            });
    }
    renderHeader() {
        const {t, viewMode} = this.props;
        return (
            <DivContainer colClass='col-12'>
                <DivContainer colClass='col-12'>
                    <label>{viewMode === 'NEW' ? t('user.addHeader') : t('user.editHeader')}</label>
                </DivContainer>
            </DivContainer>
        );
    }
    getContainerListName() {
        return 'user-list-container';
    }

    getAddSucces() {
        const {t} = this.props;
        return t('user.addUserSuccess');
    }
    getUpdateSucces() {
        return t('user.updateUserSuccess');
    }

    renderDetails() {
        return (
            <Card className='input-card-userdialog' id={this.props.od}>
                <div className='row'>
                    <InputTextComponent
                        id='firstName'
                        name='firstName'
                        label={t('user.firstName')}
                        colClass='col-md-6'
                        value={this.state.element?.firstName}
                        validator={this.validator}
                        validators='required|max:50'
                        onChange={this.handleChange}
                        viewMode={this.props.viewMode}
                    />
                    <InputTextComponent
                        id='lastName'
                        name='lastName'
                        label={t('user.lastName')}
                        colClass='col-md-6'
                        value={this.state.element?.lastName}
                        validator={this.validator}
                        validators='required|max:50'
                        onChange={this.handleChange}
                        viewMode={this.props.viewMode}
                    />
                    <InputTextComponent
                        id='email'
                        name='email'
                        label={t('user.email')}
                        colClass='col-md-6'
                        value={this.state.element?.email}
                        validator={this.validator}
                        validators='required|max:50'
                        onChange={this.handleChange}
                        viewMode={this.props.viewMode === 'EDIT' ? 'VIEW' : this.props.viewMode}
                    />{' '}
                    <InputMultiSelectComponent
                        id='roles'
                        name='roles'
                        colClass='col-md-6'
                        label={t('user.roles')}
                        value={this.state.element.roles}
                        validator={this.validator}
                        validators={'required|array_required'}
                        onChange={this.handleChange}
                        viewMode={this.userId === this.state.element.id ? 'VIEW' : 'EDIT'}
                        options={this.state.roles}
                        dataKey='enumValue'
                        optionLabel='label'
                        validateViewMode
                    />
                    {/* <InputDropdownComponent
                        id='locale'
                        name='locale'
                        label={t('user.locale')}
                        validator={this.validator}
                        validators='required'
                        value={this.state.element.locale}
                        options={this.state.locales}
                        colClass='col-md-6'
                        viewMode={'EDIT'}
                        onChange={this.handleChange}
                        rendered
                        showClear={false}
                    /> */}
                </div>
            </Card>
        );
    }
}

UserDialog.defaultProps = {
    currentUser: undefined,
    visible: false,
    stationId: undefined,
    changePackageUrl: '/change-package',
    id: 'userDialog'
};

UserDialog.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    changePackageUrl: PropTypes.string,
    currentUser: PropTypes.object,
    editUrl: PropTypes.string,
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
    elementId: PropTypes.number,
};

export default withRouter(withTranslation()(UserDialog));
